<template>
  <div ref="host" class="safe-dv-charts">
    <dv-charts-native
      v-if="ready"
      ref="charts"
      :option="normalizedOption"
    />
  </div>
</template>

<script>
import DvChartsNative from '@jiaminghi/data-view/lib/components/charts/src/main.vue'
import { waitForElementSize } from '@/util/chart-safe.js'
import { normalizeChartOption } from '@/util/chart-axis-style.js'

export default {
  name: 'SafeDvCharts',
  components: {
    DvChartsNative
  },
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ready: false,
      mountToken: 0,
      destroyed: false
    }
  },
  computed: {
    normalizedOption () {
      return normalizeChartOption(this.option)
    },
    chart () {
      return this.$refs.charts?.chart || null
    }
  },
  mounted () {
    this.scheduleMount()
  },
  beforeDestroy () {
    this.destroyed = true
    this.mountToken += 1
    this.ready = false
  },
  methods: {
    scheduleMount () {
      const token = ++this.mountToken
      this.ready = false
      this.$nextTick(async () => {
        const host = this.$refs.host
        const ok = await waitForElementSize(host)
        if (token !== this.mountToken || this.destroyed || !ok) return
        this.ready = true
        this.$nextTick(() => {
          if (token !== this.mountToken || this.destroyed) return
          this.$refs.charts?.chart?.resize?.()
        })
      })
    },
    onResize () {
      this.$refs.charts?.onResize?.()
    }
  }
}
</script>

<style scoped>
.safe-dv-charts {
  width: 100%;
  height: 100%;
  min-height: 1px;
}
</style>
